import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {CheckAuthService} from './auth/services/check-auth.service';
import {RoleScopeGuard} from './auth/services/role-scope.guard';
import {enrollmentRequiredGuard} from './auth/services/enrollment-required.guard';
import {offlineAuthRedirectGuard} from './core/offline/offline-routes';
export const routes: Routes = [


  // offlineAuthRedirectGuard: while the tab is in OFFLINE MODE there is no server to log into, so the
  // login screen (and the catch-all below, which lands here) sends it to the offline catalogue instead.
  {path: 'auth', canActivate: [offlineAuthRedirectGuard], loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)},


  {
    path: 'app',
    // enrollmentRequiredGuard is listed on BOTH canActivate and canActivateChild. canActivateChild only
    // fires when descending into a child route; canActivate fires on /app's own activation. Today /app is
    // componentless and always redirects into a guarded child, so child-only would suffice — but that is
    // an implicit invariant. Guarding canActivate too makes the forced-enrollment confinement structural,
    // so giving /app a direct component (or a child that bypasses redirection) can't silently open a hole.
    canActivate: [CheckAuthService, enrollmentRequiredGuard],
    canActivateChild: [CheckAuthService, enrollmentRequiredGuard, RoleScopeGuard],
    children: [


      {path: '', redirectTo: 'home', pathMatch: 'full'},

      {path: 'home', loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule)},

      {path: 'shop', loadChildren: () => import('./features/shop/shop.module').then(m => m.ShopModule)}, // ⚡🚀

      {path: 'prices', loadChildren: () => import('./features/prices/prices.module').then(m => m.PricesModule)}, // ⚡🚀

      {
        path: 'warehouse',
        loadChildren: () => import('./features/warehouse/warehouse.module').then(m => m.WarehouseModule),
      }, // ⚡🚀

      {
        path: 'marketplaces',
        loadChildren: () => import('./features/marketplaces/marketplaces.module').then(m => m.MarketplacesModule)
      },  // ⚡🚀

      {
        path: 'ingest',
        loadChildren: () => import('./features/ingest/ingest.module').then(m => m.IngestModule)
      }, // ⚡🚀

      {
        path: 'kiosk',
        loadChildren: () => import('./features/kiosk/kiosk.module').then(m => m.KioskModule)
      }, // ⚡🚀

      {
        path: 'ecommerce',
        loadChildren: () => import('./features/market-ecommerce/market-ecommerce.module').then(m => m.MarketEcommerceModule)
      }, // ⚡🚀

      {
        path: 'ecommerce/shippings',
        loadChildren: () => import('./features/shippings/shippings.module').then(m => m.ShippingsModule)
      }, // ⚡🚀

      {
        path: 'admin/users',
        loadChildren: () => import('./features/user-management/user-management.module').then(m => m.UserManagementModule),
        data: { roles: ['admin'] }
      },

      {path: 'settings', loadChildren: () => import('./features/settings/settings.module').then(m => m.SettingsModule)}, // ⚡🚀

      {path: 'order-status-report', loadChildren: () => import('./features/status-throughput/status-throughput.module').then(m => m.StatusThroughputModule)}, // ⚡🚀

      // Lazy, like every other feature: the set-insert configs import the whole warehouse
      // component set, so routing them eagerly put it in the initial bundle. Same three URLs
      // ('', 'loaded', ':id') -- see SetInsertOutModule.
      {path: 'set-insert-out', loadChildren: () => import('./features/warehouse/set-insert-out.module').then(m => m.SetInsertOutModule)}, // ⚡🚀


    ]
  },


  {path: '**', redirectTo: 'auth', pathMatch: 'prefix'},

];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
